import Input from "sushiweb/InputTypes/Input";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Table from "../../Common/Table";
import Label from "sushiweb/Label";
import Button from "sushiweb/Button";
import { BottomSectionModal } from "../../../constants/assets/containers";
import NoFooterModal from "../../Common/NoFooterModal";
import TableFields from "../../../constants/CapacityChange/CapacityChangeViewSlots.json";
import { bindActionCreators } from "redux";
import * as CapacityChangeActions from "../../../store/actions/CapacityChange";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import Permission from "../../Common/Permission";

const RequestViewModal = ({
  handleClose,
  capacityChangeRequest,
  updateCapacityChangeRequest,
  isStatusRequested,
  getCapacityChangeRequests,
}) => {
  const allActions = MenuActionsMappings[MenuNames.MANUAL_SLOT_CAPACITY_UPDATE];
  const [initialState, setInitialState] = useState({});
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const values = {
      "City Name": capacityChangeRequest.city_name,
      "Entity Type": capacityChangeRequest.entity_type,
      "Entity Name": capacityChangeRequest.entity_name,
      "Requested By": capacityChangeRequest.requested_by,
      "Requested At": capacityChangeRequest.requested_at,
      "Slot Capacity Date": capacityChangeRequest.date,
      Carrier: capacityChangeRequest.carrier_type,
      Status: capacityChangeRequest.status,
      "Updated By": capacityChangeRequest.updated_by
        ? capacityChangeRequest.updated_by
        : "Not Applicable",
      "Updated At": capacityChangeRequest.updated_at
        ? capacityChangeRequest.updated_at
        : "Not Applicable",
    };
    const tableData = parseTableData(
      capacityChangeRequest.capacity_change_details
    );
    setInitialState(values);
    setTableData(tableData);
  }, [capacityChangeRequest]);

  const handleAction = (action) => {
    const request = {
      request_id: capacityChangeRequest.request_id,
      status: action,
      entity_type: capacityChangeRequest.entity_type,
      entity_id: capacityChangeRequest.entity_id,
    };
    updateCapacityChangeRequest(request).then((res) => {
      if (res) {
        handleClose();
        getCapacityChangeRequests();
      }
    });
  };

  const parseTableData = (capacitiesDetails) => {
    var result = [];
    capacitiesDetails.map((capacityData) => {
      result.push({
        slot_name: capacityData.slot_name,
        total_capacity: capacityData.current_capacity,
        change_percentage: capacityData.capacity_change_percentage,
        new_capacity: Math.floor(
          parseInt(capacityData.current_capacity) +
            (parseInt(capacityData.current_capacity) *
              parseInt(capacityData.capacity_change_percentage)) /
              100
        ),
      });
    });
    return result;
  };

  const getFieldValue = (slot_data, key) => {
    return slot_data[key];
  };

  return (
    <NoFooterModal
      handleClose={handleClose}
      heading={`Request ID - ${capacityChangeRequest.request_id}`}
      id={"capacityChangeApprovalRequestsView"}
      header={true}
      modalButtons={
        isStatusRequested ? (
          <Permission requiredPerms={[allActions.APPROVE]}>
            <BottomSectionModal className="flex items-center justify-between">
              <Button
                data-testid="clearButton"
                onClick={() => handleAction("REJECTED")}
                className="sushi-btn"
                appearance="outline"
              >
                Reject
              </Button>
              <Button
                data-testid="submitButton"
                onClick={() => handleAction("APPROVED")}
                className="sushi-btn"
              >
                Approve
              </Button>
            </BottomSectionModal>
          </Permission>
        ) : null
      }
    >
      {Object.keys(initialState).map(function (inputLabel) {
        return (
          <div className="flex items-center justify-between">
            <Label style={{ width: "25%" }} className="semibold mb-10">
              {inputLabel}
            </Label>
            <Input
              style={{ width: "75%" }}
              id="sushi-input"
              data-testid={`input-${initialState[inputLabel]}`}
              label=""
              value={initialState[inputLabel]}
              disabled
            />
          </div>
        );
      })}
      {isStatusRequested ? (
        <Table
          list={tableData}
          getFieldValue={getFieldValue}
          fields={TableFields}
        />
      ) : null}
    </NoFooterModal>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    updateCapacityChangeRequest: bindActionCreators(
      CapacityChangeActions.updateCapacityChangeRequest,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(RequestViewModal);
